import { Component, Input } from '@angular/core';
@Component({
	selector: 'app-movimentacao-tab',
  	templateUrl: './tab.component.html',
  	styleUrls: ['./tab.component.scss']
})
export class MovimentacaoTabComponent{
	@Input() desativado:boolean = false;
}
